// Lib
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

// Context
import { useComponentsPool } from '../../../ComponentsPool';
// Actions
import createLoadingSelector from '../../layout/actions';
// SCSS
import '../styles/_edit_profile_popup.scss';

export default () => {
  const { Component } = useComponentsPool();
  const { t } = useTranslation();

  const head = (
    <>
      <span className="beta-badge">{t('tickets:beta_badge')}</span>
      {t('notifications:edit_notifications')}
    </>
  );

  const content = (
    <div className='beta-edit-notifications-wrapper'>
      <div className="beta-notifications-tabs-container">
        <iframe
          className="beta-notifications-iframe"
          src={`https://prototypes.merciyanis.dev/notifications?token=${localStorage.getItem('iot_rocket_access_JWT')}&workspace=${window.location.hostname.split('.')[0]}`}
          title="🆕 [PREVIEW] Notifications"
        />
      </div>
    </div>
  );

  return (
    <Component
      componentName={'Modal'}
      contentWidth={'100%'}
      contentHeight={'100%'}
      classNames={'editUser'}
      head={head}
      content={content}
      submitButton={false}
    />
  );
};
